<template>
  <div
    :class="getCss('footer-book')"
    :style="{
      display: this.styles.base.display,
      zIndex: this.styles.base['z-index'] || 99,
      ...footerDownloadContainerStyle,
    }"
    @click="handleClickEvent"
  >
    <!--  begin   显示合规 -->
    <!-- v-if="isOpenCopyRight && !!fourElementInfo.gameName" -->
    <template>
      <c-copyright
        :configuration-data="{
          gid: configurationData.gid,
        }"
        :initDataFromProp="true"
        :fourElementInfo="fourElementInfo"
        :events="events"
      />
    </template>
    <!--  end   显示合规 -->
    <!--       andriod|ios 单纯预约模式-->
    <template>
      <div :class="getCss('act_modules_action_area')">
        <div :class="getCss('act_modules_actionBtn_cloud_button_area')">
          <div :class="getCss('act_modules_actionBtn_cloud')">
            <c-button
              ref="bookButton"
              :style="computedStyle"
              v-bind="$props"
              v-text="bookText"
            />
          </div>
        </div>
        <p :class="getCss('act_modules_actionBtnTips')">
          成功预约，游戏上线后WIFI下开启快捷下载
        </p>
        <div
          :class="getCss('act_modules_ios_full_screen_bottom_bar')"
          v-if="isIosFullScreenExtra"
        ></div>
      </div>
      <!-- <c-button ref="button" v-bind="$props" /> -->
    </template>
    <CTgclubGameOrderBindPhonePop
      v-model="hasAccessBindPhone"
      v-bind="$props"
      :subscriptionData="subscriptionData"
      @closeBindOrderPhone="closeBindOrderPhoneFunc"
      :configurationData="configurationData"
    />
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import CTgclubGameOrderBindPhonePop from '@tencent/ceiba-act-tgclub-game-order-bind-phone-pop';
// import CTgclubGameOrderBindPhonePop
// from "../../../../act-tgclub-components/src/components/tgclub-game-order-bind-phone-pop";
import copyright from '@tencent/ceiba-act-public-copyright';
// import copyright from "../copyright";
// import { TgclubApi } from "../../../../act-tgclub-components/src/components/ceiba-tgclub-base-components";
import { TgclubApi } from '@tencent/ceiba-tgclub-base-components';
import button from '@tencent/ceiba-act-public-button';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import {
  TGCLUB,
  SPARK,
} from './constant.js';
const SUBSCRIBE_GAME_CHANNEL_XINYUE = 'xy'; // 预约游戏渠道心悦-xy 闪现-sx
const SUBSCRIBE_GAME_CHANNEL_SPARK = 'sx';
export default {
  name: 'CPublicFooterBook',
  components: {
    [copyright.name]: copyright,
    [button.name]: button,
    [CTgclubGameOrderBindPhonePop.name]: CTgclubGameOrderBindPhonePop,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-footer-book-',
      // 合规四要素
      fourElementInfo: {},
      //  二次推荐内容分发
      hasAccessBindPhone: false,
      hasGameBook: false, // 是非预约
      subscriptionData: {
        mobile: '', // 已经预约的手机
        isFocusOn: false, // 是否关注公众号
        switchStatus: 1, // 短信通知状态
        gid: 0,
        nickname: '',
      },
    };
  },
  computed: {
    footerDownloadContainerStyle() {
      // 预约模式
      const style = {};
      console.log(123321321);
      console.log(!this.$isInEditor, this.isIosFullScreenExtra, '123');
      // 保证在活动页面 下载组件复测
      if (!this.$isInEditor) {
        style.ZIndex = 99;
      }
      // ios全面屏
      if (this.isIosFullScreenExtra) {
        style.height = '2.3rem';
        return style;
      }
      style.height = '1.62rem' ;
      return style;
    },
    bookText() {
      return this.hasGameBook ? '已预约' : '立即预约';
    },
    // 预约游戏渠道
    subscribeGameChannel() {
      let astName = TGCLUB;
      // todo 后续 $astTgclubPlugin 变换成 $ast
      if (this.$ast.currentAstName) {
        astName = this.$ast.currentAstName();
      }
      if (astName === TGCLUB) {
        return SUBSCRIBE_GAME_CHANNEL_XINYUE;
      }
      if (astName === SPARK) {
        return SUBSCRIBE_GAME_CHANNEL_SPARK;
      }
      return SUBSCRIBE_GAME_CHANNEL_XINYUE;
    },
    computedStyle() {
      return {
        fontFamily: 'PingFang SC',
        fontSize: '0.32rem',
        lineHeight: '0.8rem',
        height: '0.8rem',
        color: this.hasGameBook === false ? '#fff' : '#D8D4D0',
        background: this.hasGameBook === false ? '#D7B386' : '#F5F3F0',
        position: 'static',
        width: '6.86rem',
      };
    },
    isOpenCopyRight() {
      const { openCopyRight = true } = this.configurationData;
      if (this.$isInEditor) return openCopyRight;
      return openCopyRight && !this.isIOS;
    },
    isIOS() {
      console.log(this.$platform.isIos, 'this.$platform.isIos');
      return this.$platform.isIos;
    },
    isIosFullScreenExtra() {
      if (this.isIOS) {
        // 解决适配部分全面屏手机底部黑条安全区域
        const list = [
          { d: 3, w: 360, h: 780 },
          { d: 3, w: 428, h: 926 },
          { d: 3, w: 390, h: 844 },
          { d: 3, w: 360, h: 780 },
          { d: 3, w: 375, h: 812 },
          { d: 2, w: 414, h: 896 },
          { d: 3, w: 414, h: 896 },
        ];
        const { screen, devicePixelRatio } = window;
        const { height, width } = screen;
        return !!list.some(item => item.d === devicePixelRatio && item.w === width && item.h === height);
      }
      return false;
    },
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$isInEditor) return;
      this.initGameBookStatus();
      this.asyncGameBookStatus();
      // 显示4要素
      this.queryGameInfoFunc();
      console.log(this.isOpenCopyRight);
      if (this.isOpenCopyRight) {
        this.queryGameInfoFunc();
      }
    },
    // 如果游戏没有配置云游戏
    async queryGameInfoFunc() {
      const { gid } = this.configurationData;
      if (gid <= 0) {
        console.warn('download not setting gid ', gid);
        return null;
      }
      let url = `https://agw.xinyue.qq.com/api/tgclub/queryGameAddress?gid=${gid}`;
      if (window.CEIBA_ENV !== 'prod') {
        url = `https://agw-p.xinyue.qq.com/api/tgclub/queryGameAddress?gid=${gid}`;
      }
      const response = await this.$axiosInstance.get(url);
      console.log('response queryGameAddress ', response);
      const { ret, data = {} } = response;
      const { ret: resRet } = data;
      if (ret !== 0 || resRet !== 0) {
        this.isInitError = true;
        this.$alert({ msg: '游戏即将开放下载，请稍后尝试' });
        return null;
      }
      this.isInitError = false;
      const {
        game_name: gameName,
        version,
        carrier = '',
        developer,
        privacy_url: privacyUrl,
        permission_url: permissionUrl,
        ios_pkg_name: iosPkgName,
        ios_download_url: iosDownloadUrl,
        qq_appid: gameQQAppid,
        android_pkg_name: packagename,
        channel_no: channelNo,
        wx_appid: gameWxAppid,
        xinyue_data: xinyueData = {},
        // android_cdn_channels: androidCdnChannels = {},
      } = data.GameInfos || {};
      console.log(
        'response queryGameAddress and  data.gameInfos = ',
        data.GameInfos,
      );
      // ##### 组装心悦app  需要拉起下载显示的数据
      // ##### ios 端外染色上报的数据
      this.deviceReportData = {
        gameQQAppid,
        gameWxAppid,
        iosPkgName,
        version,
        iosDownloadUrl,
        iOSPkgName: iosPkgName,
        packagename,
        channelid: channelNo,
      };
      // if (androidCdnChannels[queryChannelNo] && queryChannelNo) {
      //   this.deviceReportData.channelid = queryChannelNo;
      // }
      // // ##### 上报的数据
      // console.log("-----this.deviceReportData =----", this.deviceReportData);
      // ###   四要素数据
      this.fourElementInfo = {
        privacyUrl,
        permissionUrl,
        developer,
        carrier,
        version,
        gameName,
      };
      // ###   四要素数据
      console.log('-----this.fourElementInfo =----', this.fourElementInfo);
      const { cloud_game_h5_url: cloudGameH5Url = '' } = xinyueData;
      // ###   云下载数据
      if (typeof cloudGameH5Url === 'string' && cloudGameH5Url.length > 0) {
        this.isAccessCloudGame = true;
      }
      this.cloudGameInfo = {
        cloudGameH5Url,
      };
      console.log('-----this.cloudGameInfo =----', this.cloudGameInfo);
      // ###   云下载数据
      return data.GameInfos;
    },
    asyncGameBookStatus() {
      this.$eventBus.$on('ceiba:custom:events:game:book:result', async ({ status }) => {
        if (status) {
          this.hasGameBook = true;
        }
      });
    },
    async initGameBookStatus() {
      const {
        gid,
        autoBook = false,
        mustAppBook = true,
      } = this.configurationData;
      this.$onLogined(async () => {
        const res = await TgclubApi.queryUserSubscription(parseInt(gid, 10));
        console.log(res, 'res');
        if (res === false) {
          this.hasGameBook = false;
          if (autoBook) {
            // 在app 内自动预约
            if (mustAppBook && this.isApp) {
              this.doGameBook();
            }
            // H5 自动预约
            if (!mustAppBook) {
              this.doGameBook();
            }
          }
        } else if (res === true) {
          this.hasGameBook = true;
        }
      });
      this.$refs.bookButton.setClickHandler(this.doGameBook, {
        forceApp: this.configurationData.mustAppBook,
        forceLogin: true,
        forceRole: false,
      });
    },
    // 获取预约
    async doGameBook() {
      const { bookFlowId } = this.configurationData;
      console.log(bookFlowId, this.hasGameBook);
      if (this.hasGameBook === true) return;
      const response = await this.flowRequest({
        flowId: bookFlowId,
        params: {
          data: JSON.stringify({
            subscribe_game_channel: this.subscribeGameChannel,
          }),
        },
      });
      const { ret, msg, data = {} } = response || {};
      console.log('do book action response ', response);

      if (ret !== 0) {
        this.reportFunc('0', false);
        return this.$alert({ msg });
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet !== 0) {
        this.reportFunc('0', false);
        return this.$alert({ msg: resMsg || '预约失败' });
      }
      this.hasGameBook = true;
      this.callBack(); //  预约后回调
      // switchStatus 0 打开 1 关闭
      const {
        mobile = '',
        is_focus_on: isFocusOn = false,
        switch_status: switchStatus = 0,
      } = data;
      this.subscriptionData = {
        mobile,
        isFocusOn: !!isFocusOn,
        switchStatus,
        gid: this.configurationData.gid,
        nickname: this.userInfo?.nickName ?? '',
      };
      this.hasAccessDistributionContent = true;
      this.hasAccessBindPhone = true;
      this.broadcastGameBookResult(true);
      return false;
    },
    closeBindOrderPhoneFunc(silentlyDownRes) {
      console.log('silentlyDownRes book = ', !!silentlyDownRes);
      this.hasAccessDistributionContent = false;
      this.hasAccessBindPhone = false;
      this.reportFunc('1', !!silentlyDownRes);
    },
    //  存在多个预约地方的时候  同步
    broadcastGameBookResult(val) {
      this.$eventBus.$emit('ceiba:custom:events:game:book:result', {
        status: val,
      });
    },
    reportFunc(key, eventData) {
      if (typeof this.reportClickRaw === 'function' && key) {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData,
        };
        this.reportClickRaw(params);
        console.log('reportFunc key data =', params);
      }
    },
    // 预约回调
    async callBack() {
      const { callBackFlowId = 0, successCallBackMsg = '', showSuccessCallBackError = false } = this.configurationData;
      console.log('run  game book callback and callBackFlowId = ', callBackFlowId);

      if (callBackFlowId > 0) {
        const response = await this.flowRequest({
          flowId: callBackFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        this.refreshQua(); // 刷新礼包
        console.log('  game book callback  response = ', response);

        const { ret, msg = '', data = {} } = response;
        const { ret: resRet = 0, msg: resMsg =  '' } = data;
        if (ret === 0 && resRet === 0) {
          if (successCallBackMsg) {
            this.$alert({ msg: successCallBackMsg });
            return  true;
          }
        }
        if (showSuccessCallBackError === true) {
          this.$alert({ msg: msg ||  resMsg });
          return  true;
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
